module.exports = __webpack_public_path__ + "static/img/CR@3x.6aaacd96.png";